import { DesignRole, ROLE_DEFINITIONS } from "../DesignTab/GlobalDesignBar/designModules";

export const RoleChip: React.FC<{ role: DesignRole }> = ({ role }) => {
  const def = ROLE_DEFINITIONS[role];
  const Icon = def.icon;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <Icon size={16} />
      <span>{def.label}</span>
    </div>
  );
};
